module.exports = __webpack_public_path__ + "static/media/ios_logo.8a523abf.png";